<template>
	<div class="change-password-dialog">
		<el-dialog append-to-body :title="row ? '修改账号' : '添加账号'" :visible="show" :close-on-click-modal="false" width="600px" @close="closeDialog">
			<el-form ref="vForm" class="form" :model="vForm" label-width="100px" auto-complete="off" size="medium">
				<el-form-item label="真实姓名" class="form-group" prop="nickname" :rules="{ required: true, message: '真实名称必填' }">
					<el-input v-model="vForm.nickname" type="text" class="form-control" />
				</el-form-item>
				<el-form-item label="登录账号" class="form-group" prop="loginName" :rules="{ required: true, validator: validator.login_name }">
					<el-input v-model="vForm.loginName" type="text" class="form-control" placeholder="登录账号至少五位"></el-input>
				</el-form-item>
				<el-form-item label="登录密码" class="form-group" prop="password" :rules="{ required: !!validatorassword, validator: validatorassword }">
					<el-input v-model="vForm.password" type="password" class="form-control" :placeholder="row ? '选填,不填写不做修改' : '6-16位'" auto-complete="new-password" />
				</el-form-item>
				<el-form-item label="状态" class="form-group" prop="status">
					<el-radio v-model="vForm.status" :label="1">启用</el-radio>
					<el-radio v-model="vForm.status" :label="2">禁用</el-radio>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeDialog">取 消</el-button>
				<el-button type="primary" :loading="doSubmitLoading" size="small" @click="doSubmit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import validator from "./validator";

	export default {
		props: {
			show:{
				type:Boolean,
				default:false
			},
			row:{
				type:Object,
				default: null
			}
		},

		data() {
			return {
				validator,
				validatorassword: this.row ? null : validator.password,
				doSubmitLoading: false,
				vForm: {
					id: "",
					nickname: "",
					loginName: "",
					status: 1,
					password:'',
				},
				loading: false,
				regionList: [],
				regionData: []
			};
		},

		created() {
			if(this.row){
				for(let key in this.vForm){
					this.vForm[key] = this.row[key]
				}
			}
		},

		methods: {
			closeDialog() {
				this.$emit("update:show", false);
			},

			async doSubmit() {
				this.doSubmitLoading = true;
				try {
					await this.$refs.vForm.validate();
					let res = await this.api.user[this.row ? "edit" : "add"](this.vForm);
					this.$message.success(res.message);
					this.closeDialog();
					this.$emit("success", this.row ? "" : 1);
				} catch (ex) {
					console.error(ex);
				}
				this.doSubmitLoading = false;
			}
		}
	};
</script>

<style lang="scss" scoped>
	.select-box {
		position: relative;
	}

	.select-box-handle {
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		cursor: pointer;
	}

	.region-control {
		display: flex;
		align-items: center;
		margin-left: 20px;
	}
</style>
